import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect';
import checkPermission from '../../../../../Components/Hooks/PermissionHook';
import { setCommentRelationId, setCommentType } from '../../../../../slices/campaigns/reducer';
import { getComments } from '../../../../../slices/campaigns/thunk';
import { toggleCommentModal } from '../../../../../slices/modals/reducer';

function CommentBtn() {
  const dispatch = useDispatch();

  const selectState = createSelector(state => state, state => ({
    currentVersion: state.Campaign.currentVersion,
    versionPath: state.MenuData.versionPath
  }));
  const {currentVersion, versionPath} = useSelector(selectState);

  async function showComment() {
    dispatch(setCommentRelationId(currentVersion._id));
    dispatch(setCommentType("version"))
    await dispatch(getComments({ type: "version", relationId: currentVersion._id }));
    dispatch(toggleCommentModal());
  }

  return (
    <button className='btn btn-ghost-dark' onClick={showComment}>
      <i className='ri-question-answer-fill align-middle me-1'></i>
      Comments{(currentVersion?.comments > 0 ? `(${currentVersion.comments})` : null)}
    </button>
  )

}

export default CommentBtn
